export interface CodeIconProps {
  color?: string;
  className?: string;
}

export function CodeIcon({ color = "#AEADA9", className }: CodeIconProps) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M9 6L3 12l6 6M15 6l6 6-6 6"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

